const getTestId=id=>process.env.NODE_ENV==='test'||process.env.NODE_ENV==='development'?id:undefined;export default getTestId;